exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bistro-weborders-body{padding-bottom:20vh}body{font-size:16px!important;font-weight:400!important;letter-spacing:normal!important;line-height:24px!important;min-height:0!important}body,html{background-color:#fff!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/assets/site.css
// module id = 484
// module chunks = 0